import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

const APA_INSTALL_SCRIPT_QUERY_KEY = 'apa-install-script';

const getRunbookOperatorInstallScriptQueryKey = (clusterId: string) =>
  [APA_INSTALL_SCRIPT_QUERY_KEY, clusterId] as const;

const getRunbookOperatorInstallScriptQueryOptions = ({
  organizationId,
  clusterId,
}: {
  organizationId?: string;
  clusterId: string;
}) =>
  queryOptions({
    queryKey: getRunbookOperatorInstallScriptQueryKey(clusterId),
    queryFn: async () => {
      const { data } = await apiClient.apa.getRunbookOperatorInstallScript({
        organizationId: organizationId!,
        clusterId,
      });
      return data.command;
    },
    enabled: !!organizationId,
  });

export const useGetRunbookOperatorInstallScriptQuery = (clusterId: string) => {
  const { currentOrganization } = useOrganizations();

  const {
    isLoading,
    data: script,
    error,
    refetch,
  } = useQuery(
    getRunbookOperatorInstallScriptQueryOptions({
      organizationId: currentOrganization?.id,
      clusterId,
    })
  );

  return {
    isLoading,
    script,
    error,
    refetch,
  };
};
